import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { COLLECT_STATUS_CONFIG } from '../../../../constants';
import { formatTenge, getBaseUnitPrice } from '../../../../helpers';
import { CollectProductData, CollectStatus } from '../../../../types';
import * as Styled from './StatusPanels.styles';

interface OtherPricePanelProps {
  product: CollectProductData;
  onConfirm: (price: number) => void;
  onCancel: () => void;
}

const config = COLLECT_STATUS_CONFIG[CollectStatus.OTHER_PRICE];

const OtherPricePanel = ({
  product,
  onConfirm,
  onCancel,
}: OtherPricePanelProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string>('');

  const price = parseFloat(value);
  const isValid = !Number.isNaN(price) && price > 0;

  return (
    <Styled.PanelContainer
      accentColor={config.color}
      accentBackground={config.background}
      accentBorder={config.border}
    >
      <div className="panel-title">
        {t('OrderPage.Collect.OtherPriceModal.TITLE')}
      </div>
      <div className="panel-hint">
        {t('OrderPage.Collect.OtherPriceModal.BASE_PRICE', {
          price: formatTenge(getBaseUnitPrice(product)),
        })}
      </div>
      <Styled.PanelInput
        value={value}
        placeholder={t('OrderPage.Collect.OtherPriceModal.PLACEHOLDER')}
        inputMode="numeric"
        onChange={(e) => setValue(e.target.value.replace(/[^\d.]/g, ''))}
      />
      <div className="panel-actions">
        <button
          type="button"
          className="panel-button cancel"
          onClick={onCancel}
        >
          {t('OrderPage.Collect.OtherPriceModal.CANCEL')}
        </button>
        <button
          type="button"
          className="panel-button confirm"
          style={{ background: config.color }}
          disabled={!isValid}
          onClick={() => isValid && onConfirm(price)}
        >
          {t('OrderPage.Collect.OtherPriceModal.CONFIRM')}
        </button>
      </div>
    </Styled.PanelContainer>
  );
};

export default OtherPricePanel;
